<template>
  <div class="follow_upload">

    <div class="data" style="padding-top: 0">

      <div class="data_form">
        <van-form @submit="onSubmit" :show-error="false" >
          <div class="form_input">
            <div class="title titles">
                <p>就诊人</p>
                <span>{{form.patientName}}</span>
            </div>
            <div class="title titles">
                <p>上传时间</p>
                <span>{{form.createTime}}</span>
            </div>
            <!-- <van-field
                disabled
                v-model="form.patientName"
                name="patientId"
                placeholder="就诊人"
                :rules="[{ required: true, message: '请填写就诊人' }]"
            /> -->
            <div class="title">
              <p>表现现象</p>
              <p>{{ form.shows.length }}/50</p>
            </div>
            <van-field
                disabled
                v-model="form.shows"
                maxlength="50"
                name="shows"
                placeholder="表现现象"
                :rules="[{ required: true, message: '请填写表现现象' }]"
            />
            <div class="title">
              <p>具体描述</p>
              <p>{{ form.description.length }}/200</p>
            </div>
            <van-field
                disabled
                v-model="form.description"
                maxlength="200"
                type="textarea"
                name="description"
                placeholder="具体描述"
                :rules="[{ required: true, message: '请填写具体描述' }]"
            />
            <div class="title" v-if="form.allNoAdvice">
              <p>医生诊断结果</p>
            </div>
            <van-field
                v-if="form.allNoAdvice"
                disabled
                v-model="text"
                maxlength="200"
                type="textarea"
                name="description"
                placeholder="医生诊断结果"
                :rules="[{ required: true, message: '请填写医生诊断结果' }]"
            />

          </div>
        </van-form>
      </div>

      <div class="uploads">
        <!-- <p class="introduce">
          <span>功能介绍：</span>
          您好，为了更好的获得咨询帮助，请详细描述您的身体状况和诊疗经历，提出您想解决的疑问，如果有相关图片也请一并上传（包括血生化检查报告、CT等影像检查报告、心电图等功能检查报告、体检报告、病历、处方等内容）我们将安排对应的医生为您提供分析和咨询。御锦会确保您的隐私安全。
        </p> -->
<!--        <div class="van_up" style="margin-bottom: 10px"-->
<!--             @click="link_pdf(item)"-->
<!--             :key="item"-->
<!--             v-for="item in numPages" >-->
<!--            <pdf class="pdf"-->
<!--                 :page="item"-->
<!--                 :src="form.url"></pdf>-->
<!--        </div>-->


        <ul class="img">
          <li v-for="(item,index) in form.imgs" :key="index" @click="getImg(index)" >
            <van-image :src="item" alt=""/>
          </li>
        </ul>

      </div>
    </div>

    <Pdf
        v-if="showPdf"
        :parent="this"
        :show.sync="showPdf"
        :showName="'showPdf'"
        :control="true"
        :currentPages="page_pdf"
        :dochref="pdfHref"></Pdf>


  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  name: "HistoryDeta",
  data() {
    return{
      fileList: [],
      form: {
        shows: "",
        description: "",
        url: "",
      },
      text: "如出现任何身体不适，请随时到医院就医。",
      numPages: 0,
      showPdf: false,
      page_pdf: 1,
      pdfHref: "",
      See: []
    }
  },
  watch: {
    "showPdf": function (newValue) {
      console.log(newValue)
      if(newValue) {
        this.stop()
      }else {
        this.move()
      }
    }
  },
  created() {
    this.get_list(this.$route.query.id);
    this.grt_see_list()
  },
  mounted() {

  },
  methods: {
    getImg(e) {
      this.$ImagePreview({
        images: this.form.imgs,
        startPosition: e,
      });
    },
    // 获取就诊人选择器
    grt_see_list() {
      this.$get("patient/page")
          .then(res => {
            if(res) {
              console.log(res)
              this.See= res.data;
            }
          })
    },
    link_pdf(e) {
      this.page_pdf= e;
      this.showPdf= true;
    },
    //禁止滚动
    stop(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);//禁止页面滑动
    },
    /***取消滑动限制***/
    move(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflow='';//出现滚动条
      document.removeEventListener("touchmove",mo,false);
    },
    getNumPages(url) {
      let loadingTask = pdf.createLoadingTask(url)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages;
        console.log(this.numPages);
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
    get_list(y) {
      this.$get("report/upload/record",y,true)
        .then(res => {
          if(res) {
            console.log(res);

            this.form= res.data;

            // if(res.data.url) {
            //   this.getNumPages(res.data.url);
            //   this.$nextTick(() => {
            //     this.pdfHref= res.data.url;
            //   })
            // }

          }
        })
    },
    onSubmit() {

    },
    onOversize() {

    },
    afterJust() {

    }
  },
  components: {
    pdf
  }
}
</script>

<style lang="less" scoped>
  @import "../../style/Follow/FollowUpload";
  .titles{
    // justify-content: flex-end;
    margin-bottom: 0.75rem;
  }
</style>
